/**
 * Microsoft Authentication Library (MSAL) Configuration
 * This configuration is used for Azure AD authentication in the web application
 */

// MSAL configuration for the web app
export const msalConfig = {
  auth: {
    // Azure AD app registration client ID from environment
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,

    // Authority URL for your tenant
    // For multi-tenant apps, use: https://login.microsoftonline.com/common
    // For single tenant apps, use: https://login.microsoftonline.com/{tenantId}
    authority: import.meta.env.VITE_AZURE_AUTHORITY,

    // Redirect URI - must match Azure AD app registration
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI,

    // Post logout redirect URI
    postLogoutRedirectUri: import.meta.env.VITE_AZURE_POST_LOGOUT_REDIRECT_URI,

    // Important: Don't navigate to login request URL after successful authentication
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to true if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case "Error":
            console.error(message);
            return;
          case "Info":
            console.info(message);
            return;
          case "Verbose":
            console.debug(message);
            return;
          case "Warning":
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Scopes for the application
export const loginRequest = {
  scopes: [
    "User.Read", // Basic user profile information
    // "Mail.Read", // Removed: Requires admin consent - add back when admin approves
    "openid",
    "profile",
    "offline_access", // To get refresh tokens
  ],
};

// Scopes for token acquisition
export const tokenRequest = {
  scopes: ["User.Read"], // Removed Mail.Read to avoid admin consent requirement
  forceRefresh: false,
};

// Graph API endpoint
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages",
};
